/* Supplier estimates are dated evidence, not live carrier promises. */
(function (root) {
  function estimate(config, variantId, country, now = new Date()) {
    const variant = config?.variants?.[String(variantId)];
    if (variant?.unavailable_countries?.includes(country)) return null;
    const quote = variant && (variant[country] || config?.country_defaults?.[country]);
    if (!quote || !/^[A-Z]{2}$/.test(country)) return null;
    const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
    const parts = new Intl.DateTimeFormat('en', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const value = type => parts.find(part => part.type === type).value;
    const base = new Date(`${value('year')}-${value('month')}-${value('day')}T12:00:00Z`);
    const checked = Date.parse(config.checked_at);
    if (!Number.isFinite(checked) || checked > now.getTime()) return null;
    if (![quote.min_days, quote.max_days].every(Number.isInteger) || quote.min_days < 0 || quote.max_days < quote.min_days) return null;
    const result = { transit: `${quote.min_days}–${quote.max_days} days after dispatch`, checked_at: config.checked_at, date: today };
    const processing = config.processing;
    // A merchant planning allowance is explicitly distinguished from confirmed processing.
    if (!(processing?.confirmed || processing?.planning_allowance) || ![processing.min_days, processing.max_days].every(Number.isInteger) || processing.min_days < 0 || processing.max_days < processing.min_days || processing.unit !== 'calendar_days') return result;
    const format = offset => {
      const date = new Date(base);
      date.setUTCDate(date.getUTCDate() + offset);
      return new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short', year: 'numeric' }).format(date);
    };
    return { ...result, arrival: `${format(quote.min_days + processing.min_days)} – ${format(quote.max_days + processing.max_days)}`, planning: !processing.confirmed, allowance: `${processing.min_days}–${processing.max_days}` };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { estimate };
  root.AniVaultDelivery = { estimate };
  if (typeof document === 'undefined') return;
  const section = document.querySelector('[data-product-section]');
  const data = section?.querySelector('[data-delivery-config]');
  const box = section?.querySelector('[data-delivery-estimate]');
  if (!data || !box) return;
  let config;
  try { config = JSON.parse(data.textContent); } catch { return; }
  const country = box.querySelector('[data-delivery-country]');
  function render() {
    const id = section.querySelector('[data-variant-id]')?.value;
    const info = estimate(config, id, country.value);
    const text = box.querySelector('[data-delivery-text]');
    const note = box.querySelector('[data-delivery-note]');
    const orderNote = section.querySelector('[data-order-delivery-note]');
    if (orderNote) {
      const destination = country.options[country.selectedIndex]?.text || country.value;
      orderNote.value = info
        ? `Delivery to ${destination}; estimate when added on ${info.date}: ${info.arrival || info.transit}. ${info.planning ? `Includes an estimated ${info.allowance} days for preparation.` : 'Preparation time is additional unless included in the date range.'} Arrival is not guaranteed. Tracking follows dispatch. The shipping address determines delivery availability and charges.`
        : 'Contact us for a current delivery estimate. Preparation time is additional. Tracking follows dispatch.';
    }
    if (!info) {
      const unavailable = config.variants?.[String(id)]?.unavailable_countries?.includes(country.value);
      text.textContent = unavailable ? 'This style and size cannot be delivered to this country.' : 'Contact us for a current delivery estimate for this option.';
      note.textContent = unavailable ? 'Please choose a different style, size or delivery country. Your checkout address determines availability.' : 'Availability and delivery depend on your address. Tracking is sent after dispatch.';
      return;
    }
    text.textContent = info.arrival ? `Estimated delivery: ${info.arrival}` : `Estimated delivery: ${info.transit}`;
    note.textContent = info.arrival
      ? (info.planning ? `Includes an estimated ${info.allowance} days to prepare your order. Delivery times can vary. We’ll send tracking when it ships. Items may arrive separately.` : 'Includes preparation time. Delivery dates are estimates. We’ll send tracking when it ships. Items may arrive separately.')
      : 'Preparation time is extra and varies by supplier. We will send tracking after dispatch; it will show the latest delivery updates.';
    if (config.delivery_included_in_local_price) {
      note.textContent += ' Tracked delivery is included in the item price for this destination. Import taxes or customs fees may be payable separately.';
    } else if (config.eu_shipping?.additional_checkout_gbp?.[country.value] !== undefined) {
      note.textContent += ' Delivery charges depend on the country and can be higher for some larger items. Your charge is shown at checkout. Import taxes or customs fees may be payable separately.';
    }
  }
  country.addEventListener('change', render);
  section.addEventListener('anivault:variant-change', render);
  // Recalculate when returning to an open page on a later date.
  document.addEventListener('visibilitychange', () => { if (!document.hidden) render(); });
  // Keep dates current even if the product page stays open across midnight.
  setInterval(() => { if (!document.hidden) render(); }, 60000);
  render();
})(typeof window === 'undefined' ? globalThis : window);
